<template>
    <Dialog>
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>{{
                    $t("workflows.assign_workflow_modal.title")
                }}</DialogTitle>
            </DialogHeader>
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                    <div class="mt-3 w-full text-center sm:mt-0 sm:text-left">
                        <h3
                            id="modal-title"
                            class="text-lg font-medium leading-6 text-iron-900"
                        >
                            {{ $t("workflows.assign_workflow_modal.title") }}
                        </h3>
                        <div class="mt-4">
                            <div>
                                <div class="-space-y-px rounded-md bg-white">
                                    <!-- Checked: "z-10 border-indigo-200 bg-indigo-50", Not Checked: "border-iron-200" -->
                                    <div
                                        v-for="(eventType, key) in eventTypes"
                                        :key="eventType.id"
                                        class="relative flex cursor-pointer border p-4 hover:bg-iron-50 focus:outline-none"
                                        :class="{
                                            'rounded-tl-md rounded-tr-md':
                                                key === 0,
                                            'rounded-bl-md rounded-br-md':
                                                eventTypes.length === key + 1,
                                        }"
                                        @click="
                                            isWorkflowAlreadyAssigned(
                                                workflowId,
                                                eventType.workflows,
                                            )
                                                ? detachEventType(eventType.id)
                                                : assignEventType(eventType.id)
                                        "
                                    >
                                        <div
                                            class="flex items-center justify-center"
                                        >
                                            <div
                                                class="h-5 w-5 border border-iron-300"
                                            >
                                                <CheckIcon
                                                    v-if="
                                                        isWorkflowAlreadyAssigned(
                                                            workflowId,
                                                            eventType.workflows,
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <span class="ml-5 flex flex-col">
                                            <span
                                                id="privacy-setting-0-label"
                                                class="block text-sm font-medium"
                                                >{{ eventType.name }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogFooter>
                <DialogClose>
                    <button
                        type="button"
                        class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    >
                        {{ $t("close") }}
                    </button>
                </DialogClose>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import { CheckIcon } from "@heroicons/vue/24/solid";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "@/components/ui/dialog";
const props = defineProps<{
    workflowId: number;
    eventTypes: Array<any>;
}>();

const detachEventType = function (eventTypeId: number) {
    router.post(
        "/workflows/" + props.workflowId + "/event-types/detach",
        {
            eventTypeId: eventTypeId,
        },
        {
            onFinish: () => {},
        },
    );
};

const assignEventType = function (eventTypeId: number) {
    router.post(
        "/workflows/" + props.workflowId + "/event-types/assign",
        {
            eventTypeId: eventTypeId,
        },
        {
            onFinish: () => {},
        },
    );
};

const isWorkflowAlreadyAssigned = (id: number, assignedWorkflows: any) => {
    for (let i = 0; i < assignedWorkflows.length; i++) {
        if (assignedWorkflows[i].id === id) {
            return true;
        }
    }
    return false;
};
</script>

<style></style>
